<div class="modal modal-full fade" id="Observation-comment" [collapse]="isCollapsed" tabindex="-1">
  <div class="modal-dialog" role="document">
    <div class="modal-content" *ngIf="isEdit">
      <div class="modal-header border-0 mb-4">
        <h5 class="row modal-title w-100 mt-3 sticky">{{ 'SOP_MANAGEMENT.COMMENTS' | translate }}</h5>
        <button type="button" class="close" (click)="closeComments()">
          <!-- <span aria-hidden="true">&times;</span> -->
        </button>
      </div>
      <div class="comment-body modal-body ui-dialog-fixed">
        <div class="comment-card col-12">
          <div class="comment-text-container row m-0 col-12 p-0 d-flex mb-2 justify-content-between"
            *ngFor="let comment of comments;let i = index">
            <div class="col-11 comment-card-protocol">
              <p class="comment-time m-0">{{comment.commentDateTime | date:'H:mm'}}</p>
              <p class="comment-step m-0">{{(comment.stepNumber) ? ('SOP_MANAGEMENT.STEP' | translate ) + ' ' + comment.stepNumber + ' - ' +  (comment.stepName | translate) : ('SOP_OBSERVATION.NO_STEP' | translate)}}</p>
              <p class="comment-text m-0">{{getCommentText(comment)| translate}}</p>
            </div>
            <div class="p-0 col-1  d-flex align-items-center">
              <button class="delete-comment" *ngIf="isEdit" (click)="removeComment(i)"><mat-icon outline>delete</mat-icon></button>
            </div>
          </div>
          <div *ngIf="comments.length > 0" class="comment-line"></div>
        </div>
        <div class="step-selector d-flex align-items-end" *ngIf="isEdit">
          <div class="comment-bottom">

            <p class="section-label">{{ 'SOP_OBSERVATION.NO_STEP_ASSIGNED_OPTIONAL' | translate }}</p>
            <ul class="optional-div">
              {{numberToName}}
              <li class="d-flex align-items-center justify-content-center step-card" id="step-{{i + 1}}" [ngClass]="(stepNumber == (i+1))?'active':''"
                *ngFor="let name of numberToName;let i = index" (click)="stepNameNumber(i, name)">
                {{i +1}}</li>
            </ul>
            <p class="section-label">{{ 'SOP_OBSERVATION.PREDEFINED_COMMENT' | translate }}</p>
            <div class="quick-cmt-contain" >
              <ul class="quick-cmt">
                <li id="comment-{{i + 1}}" [ngClass]="(quickCommentIndex == i)?'active':''" *ngFor="let name of quickComment;let i = index"
                  (click)="clickQuickComment(i, name)">
                  {{name.commentName | translate | labelSanitizer}} </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <form (ngSubmit)="onCommentsSubmit()" *ngIf="isEdit">
        <div class="px-2 comment-area">
          <div class="pr-0 comment-div">
            <label>{{ 'CONFIGURE.WRITE_COMMENTS_HERE' | translate }}</label>
            <textarea id="comments-textarea" inputSanitizer class="text-comt" type="text" [(ngModel)]="userComment" #userCommentFrom="ngModel"
              placeholder="{{'EVALUATION.COMMENTS' | translate}}" (keydown)="onCommentsKeyDown($event)"
              maxlength="{{sopObserveCommentsMaxLength}}" [ngModelOptions]="{standalone: true}" rows="3"></textarea>
            <span class="character-count-text">{{(userComment)?userComment.length : '0'}}
              /
              {{sopObserveCommentsMaxLength}} </span>
          </div>
          <div class="d-flex justify-content-center">
            <button type="submit" class="save-btn btn-bd-empty mt-4">{{ 'CONFIGURE.SAVE_COMMENT' | translate }}</button>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-content" *ngIf="!isEdit">
      <div class="modal-header border-0 mb-4">
        <h5 class="row modal-title w-100 mt-3 sticky">{{ 'SOP_MANAGEMENT.COMMENTS' | translate }}</h5>
        <button type="button" class="close" (click)="closeComments()"></button>
      </div>
      <div class="comment-body modal-body ui-dialog-fixed">
        <div class="col-12">
          <div
            *ngFor="let comment of comments;let i = index">
            <div class="comment-card-protocol">
              <p class="comment-time m-0">{{comment.commentDateTime | date:'H:mm'}}</p>
              <p class="comment-step m-0">{{(comment.stepNumber) ? ('SOP_MANAGEMENT.STEP' | translate ) + ' ' + comment.stepNumber + ' - ' +  (comment.stepName | translate) : ('SOP_OBSERVATION.NO_STEP' | translate)}}</p>
              <p class="comment-text m-0">{{comment.freeTextComment | translate}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #delete>
  <div class="p-0 modal-header justify-content-between align-items-center ">
    <h5 class="mt-4 mb-3">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
    <a (click)="newModalRef.hide()" data-dismiss="modal" class="cursor"><img
        src="assets/ph-bhp-layout/svg/remove.svg"></a>
  </div>
  <div class="">
    <p class="">
      {{ 'SOP_OBSERVATION.CONFIRMATION.DELETE_COMMENT' | translate }}
    </p>
  </div>
  <div class="modal-footer">
    <div class="p-0 m-0">
        <div class="justify-content-end align-items-end d-flex">
        <button (click)="newModalRef.hide()" class="btn-cancel-bordered-bd">{{ 'BUTTON.CANCEL' | translate }}</button>
        <button (click)="deleteComment();newModalRef.hide()" class="btn-bd-empty ml-3">{{ 'INSTITUTION_MANAGEMENT.DELETE' | translate }}</button>
      </div>
    </div>
  </div>
</ng-template>
